import { render } from "./RegistrationPage.vue?vue&type=template&id=52f1f715&scoped=true"
const script = {}

import "./RegistrationPage.vue?vue&type=style&index=0&id=52f1f715&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52f1f715"]])

export default __exports__